// extracted by mini-css-extract-plugin
module.exports = {"image":"style_image__C5GTV","dialogOverlay":"style_dialogOverlay__uxjGG","dialogContent":"style_dialogContent__7S9eV","closeIconBttnWrapper":"style_closeIconBttnWrapper__Y_vRJ"};